

export const formatTime = (seconds: number): string => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, "0")}:${secs
        .toString()
        .padStart(2, "0")}`;
};



// Timer state management utility functions with fallback
let memoryStorage: { [key: string]: string } = {};

export const getStorageItem = (key: string | null): any | null => {
    // Accept null keys and return null immediately
    if (key === null || key === undefined) return null;


    const item = localStorage.getItem(key);


    if (item) return (JSON.parse(item));
    else if (memoryStorage[key]) return JSON.parse(memoryStorage[key]);
    else return null;


};

export const setStorageItem = (key: string, value: any): void => {
    value = JSON.stringify(value)

    if (key === null || key === undefined) return;
    try {
        localStorage.setItem(key, value);
    } catch (error) {
        console.warn('Failed to save to localStorage, using memory storage:', error);
        memoryStorage[key] = value;
    }
} 